document.addEventListener('DOMContentLoaded', function() {
  const truncateElements = document.querySelectorAll('.truncated-text');
  const charLimit = (typeof themeCharLimit !== 'undefined' && themeCharLimit !== '')
    ? Number(themeCharLimit)
    : 150;

  truncateElements.forEach(function(element) {
    const fullHtml = element.innerHTML.trim();      // keeps links, <br>, etc.
    const fullText = element.textContent.trim();    // plain text for measuring length

    if (fullText.length > charLimit) {
      const previewText = fullText.substring(0, charLimit) + '…';

      element.innerHTML = `
        <span class="preview-text"></span>
        <span class="full-text">${fullHtml}</span>
        <button class="read-more-btn">Read more</button>
      `;

      // Set preview text as textContent so we don't accidentally interpret HTML
      const previewSpan = element.querySelector('.preview-text');
      previewSpan.textContent = previewText;

      element.classList.add('is-truncated');

      const btn = element.querySelector('.read-more-btn');
      btn.addEventListener('click', function() {
        element.classList.toggle('is-truncated');
        this.textContent = element.classList.contains('is-truncated')
          ? 'Read more'
          : 'Read less';
      });
    }
  });
});
